import './src/styles/styles.css'
import React from "react"
import { StoreContextProvider } from './src/components/StoreContext'
export const wrapRootElement = ({ element }) => (
  <StoreContextProvider>{element}</StoreContextProvider>
)